import Vue from 'vue';
import Vuex from 'vuex';

import accounts from './modules/accounts';
import agents from './modules/agents';
import auth from './modules/auth';
import call from './modules/call';
import campaigns from './modules/campaigns';
import cannedResponse from './modules/cannedResponse';
import contactConversations from './modules/contactConversations';
import contactLabels from './modules/contactLabels';
import contactNotes from './modules/contactNotes';
import contacts from './modules/contacts';
import conversationLabels from './modules/conversationLabels';
import conversationMetadata from './modules/conversationMetadata';
import conversationPage from './modules/conversationPage';
import conversations from './modules/conversations';
import conversationSearch from './modules/conversationSearch';
import conversationStats from './modules/conversationStats';
import conversationTypingStatus from './modules/conversationTypingStatus';
import csat from './modules/csat';
import globalConfig from 'shared/store/globalConfig';
import inboxAssignableAgents from './modules/inboxAssignableAgents';
import inboxes from './modules/inboxes';
import inboxMembers from './modules/inboxMembers';
import integrations from './modules/integrations';
import labels from './modules/labels';
import notifications from './modules/notifications';
import reports from './modules/reports';
import teamMembers from './modules/teamMembers';
import teams from './modules/teams';
import userNotificationSettings from './modules/userNotificationSettings';
import webhooks from './modules/webhooks';
import attributes from './modules/attributes';
import automations from './modules/automations';
import customViews from './modules/customViews';
import statuses from './modules/statuses';
import usageReport from './modules/usageReport';
import grantCredit from './modules/GrantCredit';
import catalog from './modules/catalog';
import orders from './modules/orders';
import coupons from './modules/coupons';
import merchant from './modules/merchant';
import dashboard from './modules/dashboard';
import score from './modules/score';
import levels from './modules/levels';
import meetings from './modules/meetings';
import llmbots from './modules/llmbots';
import campaign_agents from './modules/campaign_agents';
import evaluations from './modules/evaluations';
import tools from './modules/tools';
import reportCosts from './modules/reportCosts';
import interactionHistories from './modules/interaction_histories';

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    accounts,
    agents,
    auth,
    call,
    campaigns,
    cannedResponse,
    contactConversations,
    contactLabels,
    contactNotes,
    contacts,
    conversationLabels,
    conversationMetadata,
    conversationPage,
    conversations,
    conversationSearch,
    conversationStats,
    conversationTypingStatus,
    csat,
    dashboard,
    evaluations,
    globalConfig,
    inboxAssignableAgents,
    inboxes,
    inboxMembers,
    integrations,
    labels,
    levels,
    notifications,
    reports,
    teamMembers,
    teams,
    userNotificationSettings,
    webhooks,
    attributes,
    automations,
    customViews,
    score,
    statuses,
    usageReport,
    grantCredit,
    catalog,
    orders,
    coupons,
    merchant,
    meetings,
    llmbots,
    campaign_agents,
    tools,
    reportCosts,
    interactionHistories,
  },
});
